import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Layout } from '../components/Layout';
import { QuoteWidget } from '../components/QuoteWidget';
import { WhyRefacing } from '../components/WhyRefacing';
import { MarqueeGallery } from '../components/MarqueeGallery';
import { TransformationSlider } from '../components/TransformationSlider';
import { ProcessGrid } from '../components/ProcessGrid';
import { Showroom } from '../components/Showroom';
import { ValueProp } from '../components/ValueProp';
import { FacebookIcon, InstagramIcon, TwitterIcon, PhoneIcon, MailIcon, MapPinIcon } from 'lucide-react';
export function LandingPage() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }
    }
  };
  return <Layout data-id="element-290">
      {/* Hero Section */}
      <header className="relative min-h-[75vh] flex flex-col lg:flex-row border-b-3 border-charcoal" data-id="element-291">
        <motion.div variants={containerVariants} initial="hidden" animate="visible" className="flex-1 bg-alabaster p-8 md:p-12 flex flex-col justify-center border-r-0 lg:border-r-3 border-charcoal" data-id="element-292">
          <div className="max-w-xl" data-id="element-293">
            <motion.span variants={itemVariants} className="inline-block bg-espresso/10 text-espresso px-4 py-2 font-bold uppercase tracking-widest text-xs mb-4" data-id="element-294">
              Premium Cabinet Refacing
            </motion.span>
            <motion.h1 variants={itemVariants} className="text-4xl md:text-6xl font-bold leading-[0.95] mb-4" data-id="element-295">
              A Stunning <br data-id="element-296" />
              <span className="italic font-serif font-normal text-espresso" data-id="element-297">
                Kitchen
              </span>{' '}
              <br data-id="element-298" />
              Transformation <br data-id="element-299" />
              At 50% Less Cost.
            </motion.h1>
            <motion.p variants={itemVariants} className="text-lg text-charcoal/60 mb-6 leading-relaxed" data-id="element-300">
              Achieve the look of a $30,000 custom kitchen remodel in just 48
              hours. Our precision refacing technology gives you brand-new doors
              and finishes without the demolition mess.
            </motion.p>
            <motion.div variants={itemVariants} className="flex flex-wrap gap-8 items-center" data-id="element-301">
              <div className="flex -space-x-4" data-id="element-302">
                {[1, 2, 3, 4].map(i => <div key={i} className="w-12 h-12 rounded-full border-4 border-alabaster bg-charcoal/10 overflow-hidden" data-id="element-303">
                    <img src={`https://i.pravatar.cc/150?u=${i}`} alt="User" data-id="element-304" />
                  </div>)}
              </div>
              <p className="text-sm font-bold" data-id="element-305">
                <span className="text-espresso" data-id="element-306">500+</span> Kitchens Refaced in
                MD/VA
              </p>
            </motion.div>
          </div>
        </motion.div>

        <div className="flex-1 bg-charcoal/5 p-6 md:p-12 flex items-center justify-center relative overflow-hidden" data-id="element-307">
          {/* Background Image for Quote Area */}
          <div className="absolute inset-0 z-0" data-id="element-308">
            <img src="https://images.pexels.com/photos/8186477/pexels-photo-8186477.jpeg?auto=compress&cs=tinysrgb&w=1200" alt="Luxury Kitchen Background" className="w-full h-full object-cover opacity-20" data-id="element-309" />
            <div className="absolute inset-0 bg-gradient-to-br from-charcoal/40 to-transparent" data-id="element-310" />
          </div>

          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-5 pointer-events-none z-0" style={{
          backgroundImage: 'radial-gradient(#1A1A1A 1px, transparent 1px)',
          backgroundSize: '24px 24px'
        }} data-id="element-311" />

          <div className="w-full max-w-md relative z-10" data-id="element-312">
            <QuoteWidget data-id="element-313" />
          </div>
        </div>
      </header>

      <MarqueeGallery data-id="element-314" />
      <WhyRefacing data-id="element-315" />
      <TransformationSlider data-id="element-316" />
      <ProcessGrid data-id="element-317" />
      <Showroom data-id="element-318" />
      <ValueProp data-id="element-319" />
    </Layout>;
}